import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import "./img.css";
import { motion } from "framer-motion";
import LatestUpdates from "./latestupdates";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';

const HeroSection = () => (
  <div className="bg-light p-4 text-center">
    <h1 className="fw-bold">USA Student Visa</h1>

  </div>
);

const ContentSection = () => (
  <div className="container">

    <p className="mt-3">
      An international education is an experience that may be enriching and rewarding for your future. A study program in the USA may help you experience new cultures, learn new ideas, and free your mind to discover the global society in which we live. The United States, a vast country traversing six time zones, is considered the land of opportunity and an exceptional education provider. It’s also a popular destination for international students seeking to study abroad in USA for undergraduate and graduate programs.
    </p>
    <p className="mt-3">
      Students who study in the States may spend time in diverse regions of America while earning credit towards a degree through volunteering, taking classes, interning, and much more. Studying abroad in America might be a highlight of your university career, and may equip you with amazing and challenging experiences that allow you to develop both professionally and academically.</p>
    <p className="mt-3"> Looking to earn your full degree in the US?<a href="https://www.studyabroad.com/full-degree-worldwide"> Check out our directory of undergraduate and graduate programs here. </a></p>
    <h4 className="fw-bold text-decoration-underline">Reasons To Study In USA Universities</h4>
    <p className="mt-3">Depending on your current education plan, you may also want to consider the various alternatives to study abroad in USA universities. For instance, you could finish your current program and pursue a graduate degree in the United States. A variety of diverse graduate programs may offer varying completion schedules or costs compared to a domestic program while giving you the experience of studying abroad in America that you desire. If you are considering pursuing your degree studies in the USA, studying abroad makes complete sense. It may present you with the contacts and network to accomplish your goals.</p>
    <h4 className="fw-bold text-decoration-underline">Benefits of Studying In USA.</h4>
    <p className="mt-3">Earning a degree from an American university may boost your professional opportunities. America hosts the most international study abroad students for many reasons: the desire to immerse yourself in American culture, use of the latest innovative technology, myriad research opportunities, academic excellence, extensive variety of study programs, and gaining unparalleled work experience in your field of study.</p>
    <p className="mt-3">A principal advantage of studying abroad in America is the potential for learning the nuances of the English language. You may find that you want to enroll in an intensive language program in conjunction with your study program in the USA if you are not fluent in English. Even if you don’t have immediate plans to utilize the English language after you graduate, the skill may prove beneficial in the future.</p>
    <h2 className="fw-bold text-decoration-underline"><b>Student Visa Requirements for USA</b></h2>
    <h4>APPLYING FOR A US STUDENT VISA? HERE’S HELP!</h4>
    <p className="mt-3">The US Government provides an opportunity to all Indian students to study in the country but as a prerequisite, you’ll have to obtain a student visa first. The visa you need will depend on your age and the type of study you wish to pursue in the US. Here’s an overview of the types of study visas and their application requirements:</p>
    <p className="mt-3"> The US Government offers three different student visa types:</p>

    <VisaTable />

    <p className="mt-3">*For detailed information, please visit the US Government’s DepAATment of State website.</p>
    <h3 className="fw-bold text-decoration-underline">Documents Required For USA Student Visa</h3>
    <p className="mt-3">When applying for your student visa for the US, you will generally need:</p>
    <ul>
      <li>A valid passport that is valid for at least six months beyond your period of stay in the US (unless exempt by country specific agreements)</li>
      <li>Acceptance at a SEVP approved school and your Form I-20</li>
      <li>Application fee payment for the SEVIS</li>
      <li>Non-immigrant visa application and the Form DS-160 confirmation page</li>
      <li>Your photograph in the requested format, and number</li>
    </ul>
    <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
  </div>
  
);

const Sidebar = () => (
 
   <Col md={12}>
     <div style={{ maxWidth: "800px", width: "100%" }}>
         <Card className="border-0 shadow-none">
         <Card.Header className="fw-bold">Latest Posts</Card.Header>
             <ListGroup variant="flush">
                 <ListGroup.Item className="border-0"><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                 <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
         </Card>
     </div>
 </Col>

);





const VisaTable = () => {
  return (
    <div className="mt-4 table-responsive">
      <Table bordered hover className="table" >
        <thead className="table-light">
          <tr>
            <th>S.No.</th>
            <th>Types of student visa</th>
            <th	>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              1
            </td>
            <td>
              F-1 Student Visa
            </td>
            <td>to study at an accredited US college or university or to study English at an English language institute</td>

          </tr>

          <tr>
            <td>
              2
            </td>
            <td>
              J Exchange Visa
            </td>
            <td>for pAATicipation in an exchange program, including high school and university study</td>

          </tr>

          <tr>
            <td>
              3
            </td>
            <td>
              M Student Visa
            </td>
            <td>for non-academic or vocational study or training in the US</td>

          </tr>

        </tbody>
      </Table>
    </div>
  );
};


const USAVisa = () => (
  <>
    <div className="container mt-4">
      <HeroSection />
      <div className="row mt-4">
        <div className="col-md-8">
          <ContentSection />
        </div>
        <div className="col-md-4">
          <Sidebar />
        </div>
      </div>
    </div>
    <LatestUpdates />

    <Footer />
  </>
);

export default USAVisa;